
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Patientforcedwarmerchandighad() {



  const cardData =
  {
    keyword: 'Patient Forced Air Warmer in Chandigarh',
    heading: 'Pharmacle Health Care Private Limited: Patient Forced Air Warmer in Chandigarh',
    headingDescription: 'Pharmacle Health Care Private Limited provides high-quality Patient Forced Air Warmer in Chandigarh, ensuring effective temperature management for patients during surgeries and critical care. Our Wallabies Warm Care systems are designed to prevent hypothermia by delivering consistent and controlled warming, enhancing patient safety and recovery. Widely used in hospitals and healthcare facilities, our forced air warmers are reliable, easy to use, and built with advanced technology. Choose Pharmacle Health Care for the best warming solutions in Chandigarh to improve patient care and clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


    "topPlaces": [
  {
    "title": "Patient Forced Air Warmer in Chandigarh – Precision Thermal Care",
    "description": "Pharmacle Health Care Private Limited provides high-performance patient forced air warmers in Chandigarh, ensuring accurate temperature regulation during surgeries, ICU care, and post-operative recovery."
  },
  {
    "title": "Advanced Forced Air Warmer System in Chandigarh",
    "description": "Our advanced forced air warmer systems deliver consistent and adjustable warming therapy, trusted by hospitals in Chandigarh to prevent perioperative hypothermia and enhance patient outcomes."
  },
  {
    "title": "Surgical Patient Forced Air Warmer in Chandigarh",
    "description": "Pharmacle Health Care Private Limited supplies surgical-grade forced air warmers in Chandigarh, designed for operation theaters to maintain stable patient body temperature and reduce surgical risks."
  },
  {
    "title": "Portable Forced Air Warmer in Chandigarh for Emergency Use",
    "description": "Lightweight and efficient, our portable forced air warmers are ideal for ambulances, mobile clinics, and emergency rooms in Chandigarh, providing rapid temperature stabilization for patients in transit."
  },
  {
    "title": "Neonatal Forced Air Warmer in Chandigarh",
    "description": "Specially engineered for NICUs and maternity wards, Pharmacle Health Care Private Limited’s neonatal forced air warmers in Chandigarh deliver gentle and precise heating for newborn safety."
  },
  {
    "title": "ICU Patient Forced Air Warming System in Chandigarh",
    "description": "Our ICU-ready forced air warming systems are widely used in Chandigarh’s hospitals, delivering steady thermal support for critically ill patients and promoting faster recovery."
  },
  {
    "title": "Preoperative & Postoperative Forced Air Warmers in Chandigarh",
    "description": "Pharmacle Health Care Private Limited provides pre- and postoperative warming solutions in Chandigarh, helping hospitals reduce complications, stabilize patients, and shorten recovery times."
  },
  {
    "title": "Veterinary Forced Air Warmer in Chandigarh",
    "description": "Supporting veterinary clinics in Chandigarh, our specialized forced air warmers ensure safe body temperature regulation for pets and animals during surgery or intensive treatment."
  },
  {
    "title": "Emergency Forced Air Warming Devices in Chandigarh",
    "description": "Pharmacle Health Care Private Limited offers emergency forced air warming devices in Chandigarh, critical for trauma care to rapidly restore body temperature in life-threatening cases."
  },
  {
    "title": "Disposable Forced Air Warming Blankets in Chandigarh",
    "description": "Pair Pharmacle Health Care Private Limited’s warmers with our disposable forced air warming blankets in Chandigarh for hygienic, single-use solutions that ensure safe and effective patient care."
  }
],

"services": [
    {
        "name": "Patient Forced Air Warmer Chandigarh",
        "description": "Pharmacle Health Care Private Limited offers patient forced air warmers in Chandigarh, designed to effectively regulate body temperature during surgeries and recovery. These warmers prevent hypothermia by providing continuous warm air circulation, ensuring patient comfort and safety."
    },
    {
        "name": "Chandigarh Forced Air Warming System",
        "description": "We provide advanced forced air warming systems in Chandigarh that maintain optimal body temperature for patients during surgeries, post-operative care, and critical treatments. These systems ensure a safe and comfortable environment for patients throughout their medical procedures."
    },
    {
        "name": "Warming Devices for Patients Chandigarh",
        "description": "Our warming devices for patients in Chandigarh are designed to regulate body temperature, preventing hypothermia and improving patient comfort during medical treatments. These devices are perfect for both surgical and recovery settings."
    },
    {
        "name": "Patient Thermoregulation Equipment Chandigarh",
        "description": "We offer patient thermoregulation equipment in Chandigarh that helps maintain a stable body temperature during medical procedures. These devices are essential for preventing temperature-related complications and ensuring patient safety and comfort."
    },
    {
        "name": "Chandigarh Warming Devices for Hospitals",
        "description": "Pharmacle Health Care supplies warming devices for hospitals in Chandigarh, designed to regulate patient body temperature in critical care settings. These devices ensure that patients are kept at a safe and comfortable temperature during surgeries and recovery."
    },
    {
        "name": "Patient Temperature Control Chandigarh",
        "description": "We provide patient temperature control solutions in Chandigarh, ensuring effective thermoregulation throughout medical treatments. These solutions are ideal for use in hospitals and healthcare facilities to prevent hypothermia and promote patient safety."
    }
],
"tableData": [
    ["- Patient Forced Air Warmer Chandigarh", "- Chandigarh Forced Air Warming System"],
    ["- Warming Devices for Patients Chandigarh", "- Patient Thermoregulation Equipment Chandigarh"],
    ["- Chandigarh Warming Devices for Hospitals", "- Patient Temperature Control Chandigarh"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers advanced patient forced air warmers in Chandigarh, designed to provide precise temperature control during medical treatments. Our technology ensures reliable performance to prevent hypothermia, enhancing patient safety in hospitals and clinics throughout Chandigarh."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We provide a wide range of patient forced air warmers in Chandigarh, including warming devices and temperature control systems. Our solutions are tailored for both surgical procedures and critical care, ensuring your patients remain comfortable and safe throughout their treatment."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our patient forced air warmers are manufactured to the highest standards, ensuring durability and long-lasting performance. Regularly tested and maintained, our warmers provide optimal reliability for continuous use in medical settings across Chandigarh."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are our top priorities. Our forced air warmers provide controlled, gentle warmth to prevent temperature-related complications during surgeries and procedures, ensuring that patients in Chandigarh are always in the safest hands."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our patient forced air warmers in Chandigarh are adaptable to various healthcare settings, including hospitals, clinics, and emergency rooms. We work closely with healthcare providers to ensure our systems meet their specific needs and improve overall patient care."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care’s patient forced air warmers are designed for seamless integration with existing medical systems in Chandigarh. Our products can be quickly implemented, ensuring smooth and efficient operation without disrupting ongoing medical procedures."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We provide expert consultation services in Chandigarh to help healthcare facilities select the right patient forced air warmers for their needs. Our team also offers ongoing support and maintenance to ensure your equipment operates efficiently and reliably."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the core of everything we do. Our patient forced air warmers are designed to prevent temperature-related issues during critical medical procedures, ensuring that every patient in Chandigarh receives the highest standard of care."
    }
]











  }


  const faqData = [
    { question: "What is a Patient Forced Air Warmer?", answer: "A Patient Forced Air Warmer is a medical device designed to maintain and regulate a patient’s body temperature by delivering warm air through a special warming blanket, which helps prevent hypothermia during surgeries and medical procedures." },
    { question: "How does the Patient Forced Air Warmer work?", answer: "The system works by using a blower to circulate warm air through a warming blanket or pad placed over the patient. This ensures consistent temperature control, helping to maintain normothermia during medical treatments." },
    { question: "Is the Patient Forced Air Warmer available in Chandigarh?", answer: "Yes, Pharmacle Health Care Private Limited provides the Patient Forced Air Warmer in Chandigarh, allowing healthcare facilities to maintain proper body temperature for patients during medical procedures." },
    { question: "What are the benefits of using a Patient Forced Air Warmer?", answer: "The benefits include preventing hypothermia, reducing surgical complications, improving patient comfort, speeding up recovery, and maintaining consistent body temperature throughout medical treatments." },
    { question: "How long can the Patient Forced Air Warmer maintain the patient’s temperature?", answer: "The Patient Forced Air Warmer can maintain the patient’s body temperature for the entire duration of the medical procedure, ensuring the patient stays at a safe and comfortable temperature." },
    { question: "Is the Patient Forced Air Warmer easy to use?", answer: "Yes, the Patient Forced Air Warmer is designed to be user-friendly, with simple controls that allow healthcare professionals to adjust temperature settings quickly and efficiently." },
    { question: "Can the Patient Forced Air Warmer be used for all types of surgeries?", answer: "Yes, the Patient Forced Air Warmer is suitable for a wide range of surgeries and medical procedures, especially where it is critical to maintain the patient’s body temperature." },
    { question: "Is the Patient Forced Air Warmer safe for all patients?", answer: "Yes, the Patient Forced Air Warmer is generally safe for most patients. However, it should always be used under the supervision of trained healthcare professionals to ensure proper temperature regulation." },
    { question: "How can I purchase a Patient Forced Air Warmer in Chandigarh?", answer: "You can contact Pharmacle Health Care Private Limited directly, and our team will assist you with purchasing and delivering the Patient Forced Air Warmer to healthcare facilities in Chandigarh." },
    { question: "Does Pharmacle Health Care provide support for the Patient Forced Air Warmer?", answer: "Yes, we provide complete support for the Patient Forced Air Warmer, including installation, training for healthcare professionals, and ongoing maintenance to ensure optimal performance." }
  ];
  
  const testimonialsData = [
    {
      text: 'We have been using the Patient Forced Air Warmer from Pharmacle Health Care in our Chandigarh hospital. It has helped maintain patient comfort and safety during surgeries, ensuring stable body temperature throughout procedures.',
      name: 'Dr. Karan Bhatia',
    },
    {
      text: 'The Patient Forced Air Warmer from Pharmacle Health Care has made a significant impact on our clinic in Chandigarh. It is easy to use and effective in regulating patient temperature, enhancing the quality of care we provide.',
      name: 'Dr. Simran Kaur',
    }
  ];
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];


  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Patient Forced Air Warmer in Chandigarh",
    "description": "Find high-quality Patient Forced Air Warmers in Chandigarh for effective patient temperature regulation during medical procedures. Our warming devices ensure patient safety and comfort in hospitals and surgical settings.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.8",
      "ratingCount": "1546"
    }
  };
  



  return (
    <div>
  <Helmet>
    <title>Patient Forced Air Warmer in Chandigarh | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Find Patient Forced Air Warmers in Chandigarh for effective temperature regulation and patient thermoregulation during medical procedures. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Patient Forced Air Warmer Chandigarh, Chandigarh Forced Air Warming System, Warming Devices for Patients Chandigarh, Patient Thermoregulation Equipment Chandigarh, Chandigarh Warming Devices for Hospitals, Patient Temperature Control Chandigarh"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
  
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/12.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Patientforcedwarmerchandighad;